"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addNavigators = void 0;
var LvFalconNavigator_1 = require("./LvFalconNavigator");
var LvFalconNavigatorNoProgressBar_1 = require("./LvFalconNavigatorNoProgressBar");
var LvFalconNavigatorNoBackground_1 = require("./LvFalconNavigatorNoBackground");
var LvFalconNavigatorShowLock_1 = require("./LvFalconNavigatorShowLock");
var LvFalconNavigatorNoBackgroundNoProgressBar_1 = require("./LvFalconNavigatorNoBackgroundNoProgressBar");
var LvFalconNavigatorNoTitle_1 = require("./LvFalconNavigatorNoTitle");
var LvFalconNavigatorWithArrowBackButtons_1 = require("./LvFalconNavigatorWithArrowBackButtons");
var LvFalconNavigatorWithArrowBackAnchors_1 = require("./LvFalconNavigatorWithArrowBackAnchors");
var LvAnnualMotorNavigator_1 = require("./LvAnnualMotorNavigator");
var LvAnnualMotorNBNavigator_1 = require("./LvAnnualMotorNBNavigator");
var LvAnnualRenewalDeclineNavigator_1 = require("./LvAnnualRenewalDeclineNavigator");
var LvAnnualMotorNavigatorNoTitle_1 = require("./LvAnnualMotorNavigatorNoTitle");
var addNavigators = function (extensions) {
    extensions.journeyComponents.addNavigatorComponent({
        id: "falcon",
        component: LvFalconNavigator_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoProgressBar",
        component: LvFalconNavigatorNoProgressBar_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoBackground",
        component: LvFalconNavigatorNoBackground_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconShowLock",
        component: LvFalconNavigatorShowLock_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualMotorNavigatorNoTitle",
        component: LvAnnualMotorNavigatorNoTitle_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoTitle",
        component: LvFalconNavigatorNoTitle_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoBackgroundNoProgressBar",
        component: LvFalconNavigatorNoBackgroundNoProgressBar_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconWithArrowBackButtons",
        component: LvFalconNavigatorWithArrowBackButtons_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconWithArrowBackAnchors",
        component: LvFalconNavigatorWithArrowBackAnchors_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualMotorNavigator",
        component: LvAnnualMotorNavigator_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualMotorNBNavigator",
        component: LvAnnualMotorNBNavigator_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualMotorRenewalDeclineNavigator",
        component: LvAnnualRenewalDeclineNavigator_1.default
    });
};
exports.addNavigators = addNavigators;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/navigator/index.js
// module id = 3473
// module chunks = 0